import { MODULE } from "./constants";
import { canAccess } from "./helpers";

export const NO_ACCESS_PATH = "/no-access";

/**
 * Longest-prefix match: pathname → module.
 * Keep prefixes specific (`/user` vs `/user-management`).
 */
export const ROUTE_PREFIX_MODULES = [
  { prefix: "/users-management", module: MODULE.userManagement },
  { prefix: "/user-management", module: MODULE.userManagement },
  { prefix: "/registration", module: MODULE.registrationManagement },
  { prefix: "/client-management", module: MODULE.clientManagement },
  { prefix: "/manage-client", module: MODULE.clientManagement },
  { prefix: "/bond-management", module: MODULE.bondManagement },
  { prefix: "/bond-directory", module: MODULE.bondManagement },
  { prefix: "/bond", module: MODULE.bondManagement },
  { prefix: "/sell-request", module: MODULE.bondManagement },
  { prefix: "/content-management", module: MODULE.cmsManagement },
  { prefix: "/manage-resource", module: MODULE.resourceManagement },
  { prefix: "/cms", module: MODULE.cmsManagement },
  { prefix: "/control-center", module: MODULE.supportTickets },
  { prefix: "/invite-partner", module: MODULE.supportTickets },
  { prefix: "/push-notifications", module: MODULE.appNotifications },
  { prefix: "/account-closure-requests", module: MODULE.closureRequests },
  { prefix: "/order-management", module: MODULE.investmentManagement },
  { prefix: "/investment-management", module: MODULE.investmentManagement },
  { prefix: "/dashboard", module: MODULE.dashboard },
  { prefix: "/user", module: MODULE.userManagement },
];

/** First allowed path wins — order matches SidebarNew. */
const LANDING_PATHS = [
  { path: "/dashboard", module: MODULE.dashboard },
  { path: "/order-management", module: MODULE.investmentManagement },
  { path: "/registration/investor", module: MODULE.registrationManagement },
  { path: "/client-management/primary", module: MODULE.clientManagement },
  { path: "/bond-management/bond-catalogue", module: MODULE.bondManagement },
  { path: "/content-management/bondsmart", module: MODULE.cmsManagement },
  { path: "/control-center/after-market-order", module: MODULE.supportTickets },
  { path: "/push-notifications/broadcast", module: MODULE.appNotifications },
  { path: "/users-management/groups", module: MODULE.userManagement },
  { path: "/account-closure-requests", module: MODULE.closureRequests },
  { path: "/manage-resource/public", module: MODULE.resourceManagement },
];

export const getModuleForPath = (pathname = "") => {
  if (pathname === NO_ACCESS_PATH) return null;

  const match = [...ROUTE_PREFIX_MODULES]
    .sort((left, right) => right.prefix.length - left.prefix.length)
    .find(
      ({ prefix }) =>
        pathname === prefix || pathname.startsWith(`${prefix}/`)
    );

  return match?.module ?? null;
};

export const getDefaultAllowedPath = (currentPath = "", access) => {
  const allowed = LANDING_PATHS.find(
    ({ path, module }) =>
      path !== currentPath && canAccess(module, access)
  );

  return allowed?.path ?? null;
};
